import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Dialog) ``;
export const Header = styled.div `
  align-items: flex-start;
  border-bottom: 1px solid ${theme.colors.borderLight};
  display: flex;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
`;
export const Title = styled(DialogTitle) `
  && {
    ${theme.typography.headingSM};
    flex-grow: 1;
    line-height: 40px;
    padding: 0;
  }
`;
export const Close = styled(IconButton) ``;
export const Body = styled(DialogContent) `
  && {
    padding: ${theme.spacing.lg} ${theme.spacing.lg};
  }
`;
export const Footer = styled(DialogActions) `
  && {
    border-top: 1px solid ${theme.colors.borderLight};
    justify-content: flex-start;
    flex-direction: row-reverse;
    gap: ${theme.spacing.xs};
    padding: ${theme.spacing.md} ${theme.spacing.lg};
  }
`;
